import api from '@/api';

import { PageResult } from '@/core/request/PageResult';

import { API_BASE_URL } from '..';
import { Nbs, NbsListRequest } from './Nbs.types';

const CONTROLLER_URL = `${API_BASE_URL}/nbs`;

export async function nbsList(
  params?: NbsListRequest,
): Promise<PageResult<Nbs>> {
  const result = (await api.get(CONTROLLER_URL, params)) as unknown;

  return result as PageResult<Nbs>;
}

export async function nbsByCode(nbsCode?: string) {
  const result = (await api.get(
    `${CONTROLLER_URL}/${nbsCode}`,
    null,
  )) as unknown;

  return result as Nbs;
}
